<template>
  <div class="xes-textarea-wrapper">
    <textarea
      ref="textarea"
      class="xes-textarea"
      type="textarea"
      autocomplete="off"
      :rows="rows"
      :placeholder="placeholderText"
      @input="handleInput($event)"
      @blur="handleCheck"
    />
    <span
      class="xes-textarea-count"
      :class="{'count-over-tip': currentTextCount > maxTextCount}"
    >{{currentTextCount}}/{{maxTextCount}}</span>
  </div>
</template>
<script>
export default {
  props: {
    rows: {
      type: String,
      default: () => '4'
    },
    placeholderText: {
      type: String,
      default: () => '请输入内容'
    },
    maxCount: {
      type: String,
      default: () => '200'
    },
    text: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    maxTextCount () {
      return this.maxCount
    },
    currentTextCount () {
      return this.text.length
    }
  },
  data () {
    return {}
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    },
    handleCheck () {
      if (this.currentTextCount > this.maxTextCount) {
        this.$emit('blurCountCheck')
      }
    },
    resetData () {
      this.$refs.textarea.value = ''
    }
  }
}
</script>
<style lang="less">
</style>


// WEBPACK FOOTER //
// packages/text-to-audio/src/xesTextarea.vue